__turbopack_context__.v({
  "button": "_8RiFmG_button",
  "default": "_8RiFmG_default",
  "ghost": "_8RiFmG_ghost",
  "icon": "_8RiFmG_icon",
  "lg": "_8RiFmG_lg",
  "link": "_8RiFmG_link",
  "md": "_8RiFmG_md",
  "outline": "_8RiFmG_outline",
  "primary": "_8RiFmG_primary",
  "secondary": "_8RiFmG_secondary",
  "sm": "_8RiFmG_sm",
});
